import {
  Hub,
  StickerType,
  TimerStickerValue,
  timerToInterval
} from 'yougile-model'
import {getColumnInterval} from '@components/sticker/my-stickers/board-stickers/sticker-settings/stopwatch/stopwatch-column-utils'
import {TimerCtl} from '@extensions/sticker/controllers/timer-ctl'

export const getTimerColor = (value: TimerStickerValue) => {
  const timerValue = timerToInterval(value.current, true)
  return timerValue?.isNegative ? 'sticker-red' : 'sticker-gray'
}

export const getStickerTimerTitle = (
  task: Hub | undefined,
  shouldResetOnMove: boolean | undefined,
  value: TimerStickerValue,
  stickerType: StickerType
): string => {
  return task && shouldResetOnMove
    ? getColumnInterval(task.location, task, value)
    : TimerCtl.formatEntry(value.current, stickerType === 'timer')
}
